import { useEffect, useRef, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { isAuth, restoreSession } from "../helper/auth";
import Sidebar from "../component/Panel/SidebarPanel";
import Absensi from "../page/Panel/Absensi";
import Dashboard from "../page/Panel/Dashboard";
import NavbarBottom from "../component/Panel/NavbarBottomPanel";
import Histori from "../page/Panel/Histori";
import Profile from "../page/Panel/Profile";
import Rekap from "../page/Panel/Rekap";
import ReportUser from "../page/Panel/ReportUser";
import ScrollToTop from "../component/common/ScrollToTop";

const PanelLayout = () => {
    const [user, setUser] = useState(() => isAuth());
    const [ready, setReady] = useState(() => !!isAuth());
    const scrollRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            let u = isAuth();
            if (!u) u = await restoreSession();
            if (!cancelled) {
                setUser(u);
                setReady(true);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    if (!ready) {
        return <div className="min-h-screen bg-zafu-cream" />;
    }

    if (user?.role !== "staff") {
        return <Navigate to="/login" />;
    }

    const data = {
        user: {
            id_user: user?.id_user,
            username: user?.username,
            nama: user?.nama,
            email: user?.email,
            id_devisi: user?.devisi,
            nama_devisi: user?.nama_devisi,
            ipAddress: user?.ipAddress
        },
    };

    return (
        <>
            <div>
                <Sidebar />
                <div
                    ref={scrollRef}
                    className="overflow-x-auto overflow-y-auto md:ml-64 h-[calc(100vh-100px)] bg-zafu-cream"
                >
                    <ScrollToTop containerRef={scrollRef} />
                    <div className="md:m-5 m-2 md:mb-0 mb-32 h-full">
                        <Routes>
                            <Route path="/dashboard" element={<Dashboard data={data} />} />
                            <Route path="/absensi" element={<Absensi data={data} />} />
                            <Route path="/histori" element={<Histori data={data} />} />
                            <Route path="/profile" element={<Profile data={data} />} />
                            <Route path="/rekap" element={<Rekap data={data} />} />
                            <Route path="/report" element={<ReportUser data={data} />} />
                        </Routes>
                    </div>
                </div>
                <NavbarBottom />
            </div>
        </>
    );
}

export default PanelLayout;
